export const getRandomHtmlColor = () => {
    // Generate a random number between 0 and 0xFFFFFF (16777215 in decimal),
    // then convert it to a hexadecimal string and pad with leading zeros if necessary
    const color = Math.floor(Math.random() * 16777215)
        .toString(16)
        .padStart(6, '0');
    // Prefix with '#' to form a valid HTML hex color code
    return `#${color}`;
};
//# sourceMappingURL=getRandomHtmlColor.js.map